$(function() {
  // TODO: Refactor implementation

  function toggleActiveState () {
    var target = $(this).data('jsToggleActiveTrigger');

    if (target) {
      $('[data-js-toggle-active-target=' + target + ']').toggleClass('is-active');
    }
  }

  $('input[type=checkbox][data-js-toggle-active-trigger]').change(toggleActiveState);
  $('[data-js-toggle-active-trigger]:not(input[type=checkbox])').click(toggleActiveState);
});
